import "./HeroImgStyles.css"

import React from 'react'

import IntroImg from "../assets/intro-bg.webp"
import { useTranslation } from "react-i18next"



const HeroImg = () => {
  const { t } = useTranslation()
  return <div className="hero">
        <div className="mask">
         <img className="into-img" src={IntroImg} alt="IntroImg"/> 
        </div>
        <div className="content">
            <h1>{t('hero.title')}</h1>
            <p>{t('hero.part')}</p>
            

        </div>
     </div>
}

export default HeroImg
